import { splitAndCapitalize } from '@builder/utils';
export const createSelectOptionByValue = (value) => {
    const label = splitAndCapitalize(value);
    return {
        value,
        label,
    };
};
